import { render } from "./CompanyEditView.vue?vue&type=template&id=fe5a0dce"
import script from "./CompanyEditView.vue?vue&type=script&lang=js"
export * from "./CompanyEditView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__